import React from 'react';
import './SimpleDiamond.css';

const SimpleDiamond = () => {
  return (
    <div className="diamondCon">
      <ul className="diamond">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
  );
};

export default SimpleDiamond; 